import { faStar, faCircle, faCopyright } from '@fortawesome/free-regular-svg-icons';

export default [faStar, faCircle, faCopyright];
